<template>
    <dx-text-box :value="value" :read-only="false" @input="input" ref="textBoxRef" :placeholder='placeholder' />

</template>
<script setup>
import { DxTextBox } from 'devextreme-vue';
import { ref } from 'vue';

const emit = defineEmits(['valueChanged', 'input']);

const props = defineProps({
    value: {
        default: '',
        required: true,
        type: [String, Number, null],
    },
    placeholder: {
        type: String,
        default: () => ''
    }
});
const textBoxRef = ref(null);
const previous = ref(props.value);
const input = () => {
    emit('input', {
        oldText: previous.value,
        newText: textBoxRef.value.instance._options._optionManager._options.text,
    });
};
defineExpose({textBoxRef});
</script>

<style lang="scss" scoped>

</style>
